import React from "react";
import { Flex } from "@chakra-ui/react";
import ReactPaginate, { ReactPaginateProps } from "react-paginate";
import "./pagination.css";

interface PaginationProps {
  totalPages: number;
  handlePageChange: ReactPaginateProps["onPageChange"];
  currentPage?: number;
}

const Pagination: React.FC<PaginationProps> = ({
  totalPages,
  handlePageChange,
  currentPage = 1,
}) => {

  return (
    totalPages ?
      <Flex justifyContent="center" mt={5}>
        <ReactPaginate
          previousLabel="Prev"
          nextLabel="Next"
          breakLabel="..."
          pageCount={totalPages}
          forcePage={currentPage - 1}
          marginPagesDisplayed={2}
          pageRangeDisplayed={2}
          onPageChange={handlePageChange}
          containerClassName="pagination"
          previousLinkClassName="paginationLink"
          nextLinkClassName="paginationLink"
          disabledClassName="paginationDisabled"
          activeClassName="paginationActive"
        />
      </Flex> : null
  );
};

export default Pagination;